import React from 'react';

export default function Spinner() {
    return(
        <div  style={{paddingLeft:'110px'}}>
            <span className="fa fa-refresh fa-spin fa-3x fa-fw text-success"></span>
            <p>Loading . . .</p>
        </div>
    );
};